import React, { Component } from "react";
import { I18n } from "react-redux-i18n";
import styles from "./Languages.css";
import { LANGS } from "../../constants/index";
import Overlay from "../Overlay/Overlay";
import Dialog from "../Dialog/Dialog";

export default class Languages extends Component {
  render = () => (
    <Overlay show={this.props.show}>
      <div className={styles.languages}>
        <Dialog
          onClose={this.handleCloseClick}
          heading={I18n.t("language.heading")}
        >
          <div className={styles.wrapper}>
            <nav>{this.renderLanguages()}</nav>
          </div>
        </Dialog>
      </div>
    </Overlay>
  );

  renderLanguages = () =>
    Object.keys(LANGS).map(lang => (
      <button
        key={lang}
        onClick={this.handleLangClick(lang)}
        className={`${styles.lang} ${this.props.lang === lang &&
          styles.active}`}
      >
        <figure className={styles.flag}>{lang}</figure>
        {LANGS[lang]}
      </button>
    ));

  handleLangClick = lang => () => this.props.setLang(lang);

  handleCloseClick = () => this.props.hideLanguages();
}



// WEBPACK FOOTER //
// ./src/components/Languages/Languages.js